import React, { useState } from "react";
import { getConsent, setConsent } from "../consent";

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !getConsent());

  if (!visible) return null;

  const choose = (value) => {
    setConsent(value);
    setVisible(false);
  };

  return (
    <div
      className="fixed inset-x-4 bottom-4 z-[60] mx-auto max-w-2xl rounded-3xl border border-black/[0.06] bg-white p-5 preview-shadow-lift sm:inset-x-auto sm:left-6 sm:bottom-6 sm:p-6"
      role="dialog"
      aria-label="Cookies"
      data-testid="cookie-banner"
    >
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:gap-6">
        <p className="text-left text-[14px] leading-relaxed text-[#111827]/75">
          Jeg bruger cookies til anonym besøgsstatistik (Google Analytics), så jeg kan gøre siden bedre.
          Du vælger selv, om det er okay.
        </p>
        <div className="flex flex-shrink-0 gap-2">
          <button
            type="button"
            onClick={() => choose("declined")}
            className="rounded-full border border-[#852936]/30 px-4 py-2.5 text-[14px] font-medium text-[#852936] transition-colors hover:border-[#852936]"
            data-testid="cookie-decline"
          >
            Kun nødvendige
          </button>
          <button
            type="button"
            onClick={() => choose("accepted")}
            className="rounded-full bg-[#852936] px-5 py-2.5 text-[14px] font-semibold text-white transition-transform hover:scale-[1.03]"
            data-testid="cookie-accept"
          >
            Accepter
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
